export default __webpack_public_path__ + "static/media/psc.b91d0ca1.png";